import {OrderService, AuthService, RegionService, ContactUsService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
	data(){
        return {
            loading: true,
            user: null,
            subsClub: null,
            showFacebookPixel: false,
        }
    },

     methods: {
        setUser(){
            return AuthService.user().then((user)=> {
                this.user = user;
                this.isGuest = user.isGuest();
                if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                    // this.cookieActive = false;
                    // this.first_time = false;
                } else {
                    // this.showUserActivation = false;
                }

                return this.user
            })
        },

        getSubsData() {
            let subsClubRaw = window.localStorage.getItem('subsClub');

            let subsClub = null
            if(subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw)
            }

            this.subsClub = subsClub
            return subsClub
        },

        // updateUser(transactionId) {
        //     if(this.user != undefined && this.user != null) {
        //         if(!this.user.isGuest()) {
        //             if(transactionId != undefined && transactionId != null) {
        //                 if(transactionId == "8000000004") {
        //                     if(!this.user.PreferenceList.includes(5)) {
        //                         this.user.PreferenceList.push(5)
        //                     }
        //                 } else if(transactionId == "8000000003") {
        //                     if(!this.user.PreferenceList.includes(6)) {
        //                         this.user.PreferenceList.push(6)
        //                     }
        //                 }

        //                 if(!this.user.MemberLevelId != 1) {
        //                     this.user.MemberLevelId = 1
        //                 }

        //                 return AuthService.updateUser(this.user).then(() => {
        //                     window.localStorage.removeItem("subsClub")
        //                     return true;
        //                 });
        //             }
                    
        //         }
        //     }
        // },

        continueToBook() {
            this.$router.push('/')
        },

        continueToDashboard() {
            this.$router.push('/user/profile')
        },

        faceBookPixel() {
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}

              (window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '2280338928886721');
              fbq('track', 'PageView');
            
              this.showFacebookPixel = true

              return this.showFacebookPixel
        }
    },

	created(){
        console.log(this.$route)
        Promise.all([this.setUser(), this.getSubsData(), this.faceBookPixel()]).then(([user, subs, faceBookPixel])=> {
            // if(this.subsClub != undefined && this.subsClub != null) {
            //     Promise.resolve(this.updateUser(this.$route.params.transactionId)).then((user) => {
            //         if (!user) Error('Could not update user')
            //     })
            //     .catch(error => Error(error))
            // } else {
            //     throw Error('Server error')
            // }

            this.loading = false
        })
    },
}



// WEBPACK FOOTER //
// ./src/components/pages/subscribe-process/subscribe-process.js